"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "webLightTheme", {
    enumerable: true,
    get: ()=>webLightTheme
});
const _createLightTheme = require("../../utils/createLightTheme");
const _brandColors = require("../../global/brandColors");
const webLightTheme = /*#__PURE__*/ (0, _createLightTheme.createLightTheme)(_brandColors.brandWeb); //# sourceMappingURL=lightTheme.js.map

//# sourceMappingURL=lightTheme.js.map